<template>
  <div class="">
    <label v-if="label">{{label}}</label>
    <b-dropdown class="dropdown-select" :text="getCurrentDropDown">
      <slot></slot>
      <b-dropdown-item
        v-for="(item, index) in items"
        :key="index"
        @click.prevent="setValue(item)"
      >
        {{item[selectLabel]}}
      </b-dropdown-item>
    </b-dropdown>
  </div>
</template>

<script>
export default {
  props: {
    items: {
      type: Array
    },
    selectLabel: {
      type: String,
      default: 'name'
    },
    valueField: {
      type: String,
      default: 'id'
    },
    label: {
      type: String
    },
    value: [String, Number, Object]
  },
  computed: {
    getCurrentDropDown () {
      let currentItem

      if (this.value) {
        currentItem = this.items.find(item => item[this.valueField] === this.value[this.valueField])
      }

      if (!currentItem) return ''

      return currentItem[this.selectLabel]
    }
  },
  data () {
    return {

    }
  },
  methods: {
    setValue (data) {
      this.$emit('input', data)
    }
  }
}
</script>

<style lang="scss" scoped>
  .dropdown-select{
    width: 100%;
    background: url("data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 4 5'%3e%3cpath fill='%23343a40' d='M2 0L0 2h4zm0 5L0 3h4z'/%3e%3c/svg%3e") no-repeat right 0.75rem center/8px 10px;
    cursor: default;
    margin-bottom: 1rem;
    .btn-primary{
      background-color: #007bff;
      border-color: #007bff;
      &:hover,
      &:focus,
      &:active{
        background-color: #007bff !important;
        border-color: #007bff !important;
      }
    }
    &.show .dropdown-toggle {
      background-color: transparent !important;
      border-color: #80bdff !important;
      box-shadow: 0 0 0 0.2rem rgba(0, 123, 255, 0.25);
      color: #495057 !important;
    }
    .dropdown-toggle{
      color: #495057;
      background-color: transparent;
      border-color: #ced4da;
      text-align: left;
      cursor: default !important;
      height: 38px;
      &:hover,
      &:focus,
      &:active {
        color: #495057 !important;
        border-color: #ced4da;
        background-color: transparent !important;
      }
      &:after{
        content: none;
      }
      &:active,
      &:focus {
        background-color: transparent !important;
        border-color: #80bdff !important;
        box-shadow: 0 0 0 0.2rem rgba(0, 123, 255, 0.25) !important;
      }
    }
    .dropdown-menu{
      width: 100%;
      height: 200px;
      overflow: auto;
    }
    .dropdown-item, .b-dropdown-text{
      padding-left: 0.5rem;
      padding-right: 0.5rem;
    }
  }
</style>
